/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserInfoResult } from '../../models/get-user-info-result';

export interface GetUserInfo$Params {}

export function getUserInfo(
  http: HttpClient,
  rootUrl: string,
  params?: GetUserInfo$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetUserInfoResult>> {
  const rb = new RequestBuilder(rootUrl, getUserInfo.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserInfoResult>;
    }),
  );
}

getUserInfo.PATH = '/Authentication/user-info';
